module.exports = __webpack_public_path__ + "img/b_Anevil_right.0ed9f7e8.jpeg";